export default __webpack_public_path__ + "static/media/course_3.03ada53d.png";